<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { ref, inject, onMounted } from 'vue';

const backendApi = inject('backendApi');

const emit = defineEmits(['update', 'update:focused']);
const props = defineProps({
    agencyId: {},
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const loading = ref(true);
const account = ref([]);
const showRetryButton = ref(false);
const searchQuery = ref('');

const getAccount = () => {
    cleanData();

    backendApi()
        .account({
            agency: props.agencyId,
            pattern: searchQuery.value,
            active: true
        })
        .index()
        .then(success, fail)
        .finally(() => (loading.value = false));

    function success(response) {
        account.value = response.data;
    }

    function fail() {
        showRetryButton.value = true;
    }
};

const cleanData = () => {
    account.value = [];
    loading.value = true;
    showRetryButton.value = false;
};

onMounted(() => getAccount());
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :items="account"
        item-title="bankName"
        item-value="id"
        :label="hideLabel ? '' : $t('Account')"
        :loading="loading"
        :show-retry-button="showRetryButton"
        @update="emit('update', selected)"
        @preparing-search="cleanData"
        @search="getAccount"
        @retry="getAccount"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.bankName}`"
                :subtitle="`${
                    item.raw.holderName ? item.raw.holderName : ''
                } ~ ${item.raw.number ?? ''}`"
            ></v-list-item>
        </template>
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
